class CCMApp {

    constructor() {
        this.step = 1;
        this.main = $('main');
        this.clearMarkedLocation = $('#clear-marked-location');
        this.formBox = $('#form-box');
        this.form = this.formBox.find('form');
        this.cta = this.formBox.find('.cta');
        this.location = $('.location-label');
        this.back = $('#back');

        this.initVisitorSourceData();
        this.bindEventHandlers();
    }

    bindEventHandlers() {
        this.clearMarkedLocation.click(() => {
            this.clearMarker();
            this.markedLocation = null;
            this.formBox.addClass('d-none');
            this.main.removeClass('step-1');
        });

        this.cta.click(() => {
            switch (this.step) {
                case 1:
                    if (window.non_us_address === true) {
                        swal(
                            'Oops',
                            'Sorry but we only allow submissions from the United States.',
                            'warning'
                        );
                        return;
                    }
                    this.step = 2;
                    this.main.addClass('step-2');
                    this.formBox.attr('data-step', 2);

                    $('.step-1').hide('fast', () => {
                        $('.step-2').show('fast');
                    });

                    this.cta.html('Submit Coverage Issue');
                    break;

                case 2:
                    if (this.formBox.validate()) {
                        this.cta.addClass('submitting');
                        this.formBox.find('form').submit();
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({'event': 'coverage-issue-submitted'});
                    }
                    break;
            }
        });

        this.back.click(() => {
            this.step = 1;
            this.main.removeClass('step-2');
            this.formBox.attr('data-step', 1);

            $('.step-2').hide('fast', () => {
                $('.step-1').show('fast');
            });

            this.cta.html('Describe Coverage Issue');
        });
    }

    initSearchBox() {
        let input = document.getElementById('search');
        this.searchBox = new google.maps.places.SearchBox(input);

        // which page is this?
        if (this.map) {

            // start page
            this.map.addListener('bounds_changed', () => {
                this.searchBox.setBounds(this.map.getBounds());
            });

            this.searchBox.addListener('places_changed', () => {
                let places = this.searchBox.getPlaces();

                if (places.length == 0) {
                    return;
                }

                this.map.panTo(places[0].geometry.location);
                this.map.setZoom(CCMApp.getIdealZoomLevel());
            });
        } else {

            // homepage
            this.searchBox.addListener('places_changed', () => {
                let places = this.searchBox.getPlaces();
                let place  = places[0];

                CCMApp.startSubmission(place);
            });
        }
    }

    static startSubmission(place) {

        let address = CCMApp.getAddressObject(place.address_components);

        let form = $('<form></form>')
            .attr({
                method: 'post',
                action: '/start',
                style: 'display: none'
            })
            .append(
                $('<input>').attr({
                    type: 'hidden',
                    name: 'formattedAddress',
                    value: place.formatted_address
                })
            )
            .append(
                $('<input>').attr({
                    type: 'hidden',
                    name: 'lat',
                    value: place.geometry.location.lat
                })
            )
            .append(
                $('<input>').attr({
                    type: 'hidden',
                    name: 'lng',
                    value: place.geometry.location.lng
                })
            );

        $('body').append(form);
        form.submit();
    }

    static getIdealZoomLevel(initialPageLoad) {
        switch (true) {
            case window.innerWidth >= 1200: // large desktop
                return initialPageLoad ? 5 : 17;

            case window.innerWidth >= 992: // desktop
                return initialPageLoad ? 4 : 16;

            case window.innerWidth >= 768: // tablet
                return initialPageLoad ? 4 : 17;

            default: // mobile
                return initialPageLoad ? 4 : 18;
        }
    }

    initMap() {
        this.geocoder = new google.maps.Geocoder();

        let usa = {lat: window.lat, lng: window.lng};

        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: CCMApp.getIdealZoomLevel(true),
            center: usa,
            mapTypeControl: true,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
        });

        this.bindMapClickHandler();
    }

    bindMapClickHandler() {
        google.maps.event.addListener(this.map, 'click', event => {
            this.geocoder.geocode({
                'latLng': event.latLng
            }, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {

                    let place = results[0];

                    let address = CCMApp.getAddressObject(place.address_components);

                    if (address.country !== 'US') {
                        window.non_us_address = true;
                    } else {
                        window.non_us_address = false;
                    }

                    if (this.marker) {
                        this.clearMarker();
                    }

                    this.markedLocation = {address: address, latLng: event.latLng};

                    this.location.html(address.location);

                    this.form.find('[name="lat"]').val(place.geometry.location.lat);
                    this.form.find('[name="lng"]').val(place.geometry.location.lng);
                    this.form.find('[name="location"]').val(address.location);
                    this.form.find('[name="location_data"]').val(JSON.stringify(place.address_components));
                    this.form.find('[name="country"]').val(address.country);
                    this.form.find('[name="city"]').val(address.city);
                    this.form.find('[name="county"]').val(address.county);
                    this.form.find('[name="region"]').val(address.region);
                    this.form.find('[name="address"]').val(address.address);

                    this.marker = new google.maps.Marker({
                        position: event.latLng,
                        icon: {
                            url: window.location.origin + '/images/marker.png',
                            anchor: new google.maps.Point(49, 49)
                        },
                        map: this.map,
                        animation: google.maps.Animation.BOUNCE
                    });

                    this.map.setCenter(event.latLng);
                    this.map.setZoom(CCMApp.getIdealZoomLevel());

                    this.formBox.removeClass('d-none');
                    this.main.addClass('step-1');
                }
            });
        });
    }

    clearMarker() {
        this.marker.setMap(null);
    }

    static getAddressObject(address_components) {
        let ShouldBeComponent = {
            home: ["street_number"],
            postal_code: ["postal_code"],
            street: ["street_address", "route"],
            region: [
                "administrative_area_level_1",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "administrative_area_level_4",
                "administrative_area_level_5"
            ],
            city: [
                "locality",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "sublocality_level_3",
                "sublocality_level_4"
            ],
            county: [
                "administrative_area_level_2"
            ],
            country: ["country"]
        };

        let address = {
            home: "",
            postal_code: "",
            street: "",
            region: "",
            city: "",
            county: "",
            country: "",
            address: ""
        };

        address_components.forEach(component => {
            for (var shouldBe in ShouldBeComponent) {
                if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                    if (shouldBe === "country" || shouldBe === "administrative_area_level_2") {
                        address[shouldBe] = component.short_name;
                    } else {
                        address[shouldBe] = component.long_name;
                    }
                }
            }
        });

        if (address.street != '') {
            address.location = address.street +', '+ address.city +', '+ address.region;

            address.address = address.street;

            if (address.home != '') {
                address.address = address.home + ' ' + address.address;
            }
        } else {
            address.location = address.city +', '+ address.region;
        }

        return address;
    }

    initVisitorSourceData() {
        this.form.find('[name="type"]').val(sbjs.get.current.typ);
        this.form.find('[name="utm_source"]').val(sbjs.get.current.src);
        this.form.find('[name="utm_medium"]').val(sbjs.get.current.mdm);
        this.form.find('[name="utm_campaign"]').val(sbjs.get.current.cmp);
        this.form.find('[name="utm_content"]').val(sbjs.get.current.cnt);
    }
}